import axios from "axios";
import { Global } from "../../config/global";


// handleOperatorAsing: Función para asignar un chat a un operador.

export const handleOperatorAsing = async (idUsuario, idChat) => {
    try {
        let token = localStorage.getItem('token'); // Extraer el token del localStorage.
        let url = Global.url + "chat/asignar";
        let headers = { // Definir el encabezado de la petición.
            Authorization: `Bearer ${token}`
        };
        console.log(url, idUsuario, idChat)
        const response = await axios.post(url, {
            "IdChat": idChat,
            "IdUsuario": idUsuario
        }, { headers });

        console.log("se asignó el chat", response);
        return response;
    } catch (error) {
        console.log("error al asignar el chat: ", error);
        return { status: 500, data: null }; // Manejo del error: retorna un objeto de respuesta con un código de estado 500.
    }
};
